<template>
  <div :key="refresher">
    <div class="item" v-for="item in treeLocationsArr">
      <h3>
        <CBadge color="primary">{{item.nazwa}}</CBadge>
        <a @click.prevent="mthRemoveRelationFromKatalogTreeProducts(item.id)" class="red">[X]</a>
      </h3>
    </div>
    <div>
      <!-- selected:{{selected}} selectedid:{{selectedid}} -->
      <select v-bind:value="selected" @change="mthEmitModelToParent($event)">
        <option v-for="item in datamain" :value="item[valuefield]">{{item[displayfield]}}</option>
      </select>
    </div>
    <!-- {{productsTreeArr}} -->
    <!-- {{datamain}} -->
  </div>
</template>

<script>
export default {
  props: ["table", "selected","orderby","type","displayfield","valuefield"], //type can be nodeletefield
  data() {
    return {
      //mine
      datamain: [],
      selectedid: -1,
      //copied
      addNewLocationDropdownSelectedItem: null,
      refresher: 0,
      treeLocationsArr: [],
      productsTreeArr: [],
    };
  },
  created() {
    console.log('sql says hello');
    this.mthFillData();
    this.mthCopyPropToData();
  },
  methods: {
    mthEmitModelToParent(event){
      this.$emit("emitedChanged", event);
    },
    mthNoUndef(x){
      if(x===undefined) return "";

      return x;
    },
    mthCopyPropToData() {
      setTimeout(() => {
        this.selectedid = this.selected;
      }, 1000);
    },
    mthFillData() {
      var apiurl =
        process.env.VUE_APP_API_URL +
        "/b2bstar?a=" +
        this.table +
        "&type="+this.mthNoUndef(this.type)+"&limit=200&orderby=" +
        encodeURIComponent(this.orderby);

        //console.log(apiurl);
        

      var that = this;

      this.$axios({
        method: "get",
        url: apiurl,
      })
        .then(function (response) {
          console.log(response.data);
          that.datamain = response.data;
        })
        .catch(function (error) {
          console.log(error);
          that.loginsuccess = false;
          that.loginresultmsg = "Brak połączenia z API (" + error + ").";
        });
    },
  },
};
</script>

<style scoped>
.red {
  color: red;
}
.bold {
  font-weight: bold;
}
.option1 {
  background-color: black;
  color: white;
}
.option2 {
  background-color: gray;
  color: white;
}
.option3 {
  background-color: lightgray;
  color: black;
}
.option4 {
  background-color: white;
  color: gray;
}
.btnAddToTree {
  display: block;
  width: 200px;
  margin-top: 3px;
}
</style>